// Site suspended due to non-payment
// Redirecting to maintenance page
window.location.href = '/maintenance.html';
